<template>
  <div>
    <vue-toastr ref="toast"></vue-toastr>
    <table class="table table-bordered mb-0">
      <thead>
      <tr>
        <th>ID</th>
        <th>Warengruppe</th>
        <th>Betrag (€)</th>
        <th>Punkte</th>
        <th>Startdatum</th>
        <th>Enddatum</th>
        <th>Aktionen</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in items" :key="item.id || 'new-' + index">
        <td>{{ item.id }}</td>
        <td>
          <select v-model="item.product_group" :disabled="!item.editing" class="form-control">
            <option v-for="(label, value) in productGroups" :key="value" :value="value">
              {{ label }}
            </option>
          </select>
        </td>
        <td>
          <input
              v-model.number="item.earn_from_amount"
              :disabled="!item.editing"
              class="form-control"
              min="0"
              type="number"
          />
        </td>
        <td>
          <input
              v-model.number="item.earn_to_points"
              :disabled="!item.editing"
              class="form-control"
              min="0"
              type="number"
          />
        </td>
        <td>
          <input v-model="item.valid_from" :disabled="!item.editing" class="form-control" type="date"/>
        </td>
        <td>
          <input v-model="item.valid_until" :disabled="!item.editing" class="form-control" type="date"/>
        </td>
        <td class="text-center">
          <button v-if="!item.editing" class="btn btn-outline btn-warning" type="button" @click="editItem(index)">
            <i class="fa fa-pencil"></i>
          </button>
          <button v-if="item.editing" :disabled="saving" class="btn btn-outline btn-primary" type="button"
                  @click="saveItem(index)">
            <i class="fa fa-check"></i>
          </button>
          <button :disabled="saving" class="btn btn-outline btn-danger" type="button"
                  @click="deleteItem(item.id, index)">
            <i class="fa fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <button class="btn btn-block btn-outline btn-info btn-sm" type="button" @click="addItem($event)">
      <i class="fa fa-plus"></i> Hinzufügen
    </button>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import axios from "axios";

export default {
  name: "LoyaltySettingsTable",
  components: {VueToastr},
  data() {
    return {
      items: [],
      productGroups: {},
      saving: false,
    };
  },
  props: {
    settingId: {
      type: [String, Number],
      required: true
    },
    clientId: {
      type: [String, Number],
      required: true
    },
    adjustment: Object,
  },
  mounted() {
    this.fetchProductGroups();
    this.fetchAdjustments();
  },
  methods: {
    async fetchProductGroups() {
      try {
        const response = await axios.get(`/backend/loyalty-program/settings/product-groups/${this.clientId}`);
        this.productGroups = response.data;
      } catch (error) {
        this.$refs.toast.e("Warengruppen konnten nicht geladen werden.", "Fehler");
      }
    },
    async fetchAdjustments() {
      try {
        const response = await axios.get(`/backend/loyalty-program/settings/${this.settingId}/adjustments`);
        this.items = response.data.adjustments.map(adjustment => ({
          id: adjustment.id,
          product_group: adjustment.product_group,
          earn_from_amount: adjustment.earn_from_amount,
          earn_to_points: adjustment.earn_to_points,
          valid_from: adjustment.valid_from || "",
          valid_until: adjustment.valid_until || "",
          editing: false
        }));
      } catch (error) {
        this.$refs.toast.e("Fehler beim Laden der Einstellungen.", "Fehler");
      }
    },
    addItem() {
      this.items.push({
        id: null,
        product_group: "",
        earn_from_amount: 0,
        earn_to_points: 0,
        valid_from: "",
        valid_until: "",
        editing: true
      });
    },
    editItem(index) {
      this.items[index].editing = true;
    },
    async saveItem(index) {
      this.saving = true;
      const item = this.items[index];

      const payload = {
        id: item.id,
        loyalty_setting_id: this.settingId,
        product_group: item.product_group,
        earn_from_amount: item.earn_from_amount,
        earn_to_points: item.earn_to_points,
        valid_from: item.valid_from,
        valid_until: item.valid_until,
      };

      try {
        let response;
        if (item.id && item.id !== this.settingId) {
          const adjustmentId = Number(item.id);
          response = await axios.put(`/backend/loyalty-program/settings/${this.settingId}/adjustments/${adjustmentId}`, payload);
        } else {
          response = await axios.post(`/backend/loyalty-program/settings/${this.settingId}/adjustments`, payload);
          item.id = response.data.adjustment.id;
        }
        item.editing = false;
        this.$refs.toast.s("Abweichung erfolgreich gespeichert!", "Erfolg");
      } catch (error) {
        console.error(error.response?.data || error.message);
        this.$refs.toast.e("Fehler beim Speichern der Abweichung.", "Fehler");
      } finally {
        this.saving = false;
      }
    },
    async deleteItem(id, index) {
      if (!id) {
        this.items.splice(index, 1);
        return;
      }

      if (!confirm("Möchten Sie diese Abweichung wirklich löschen?")) {
        return;
      }

      this.saving = true;
      try {
        await axios.delete(`/backend/loyalty-program/settings/${this.settingId}/adjustments/${id}`);
        this.items.splice(index, 1);
        this.$refs.toast.s("Abweichung erfolgreich gelöscht!", "Erfolg");
      } catch (error) {
        this.$refs.toast.e("Fehler beim Löschen der Abweichung.", "Fehler");
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.table {
  margin-top: 20px;
}
</style>